<script setup lang="ts">
import MissingInfoImage from "@/assets/pngs/MissingInfo.png?w=300&h=358&format=webp&imagetools"
import PreviewTable from "@/components/ListImport/PreviewTable.vue"
import Loading from "@/components/Loading.vue"

import { useListImportStore } from "@/stores"

interface Emits {
  (event: "disableImport", disableImport: boolean): void
}

const emit = defineEmits<Emits>()

const listImportStore = useListImportStore()
</script>

<template>
  <div class="flex w-full flex-1 flex-col overflow-auto">
    <div class="flex items-center gap-2 pb-4">
      <h2 class="text-sm font-bold">
        Selected and matched data
      </h2>
    </div>

    <template v-if="listImportStore.allowImport">
      <Suspense>
        <PreviewTable @disable-import="emit('disableImport', $event)" />
        <template #fallback>
          <Loading class="m-auto size-40" />
        </template>
      </Suspense>
    </template>
    <div
      v-else
      class="my-2 flex min-h-96 items-center justify-center rounded-md bg-gray-100"
    >
      <div class="flex flex-col items-center p-4 md:flex-row">
        <div>
          <img
            :src="MissingInfoImage"
            class="w-52 px-8"
            alt=""
          >
        </div>
        <div class="space-y-4 md:w-80">
          <h2 class="text-lg font-bold">
            Nothing to preview yet
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>
